import React, { useEffect } from "react";
import "../css/PaintEditorModal.css";
import PaintEditor from "./PaintEditor";

export default function PaintEditorModal({
  open,
  onClose,
  initialHeading = "",
  onHeadingChange,
  ...rest
}) {
  useEffect(() => {
    if (!open) return;
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previous;
    };
  }, [open]);

  if (!open) return null;

  const handleSave = (dataUrl, headingValue) => {
    if (typeof rest.onSave === "function") {
      rest.onSave(dataUrl, headingValue);
    }
    onClose();
  };

  return (
    <div className="paint-modal-shade" onClick={onClose}>
      <div className="paint-modal-main" onClick={(e) => e.stopPropagation()}>
        <PaintEditor
          {...rest}
          initialHeading={initialHeading}
          onHeadingChange={onHeadingChange}
          onSave={handleSave}
          onClose={onClose}
        />
      </div>
    </div>
  );
}
